(() => {
  const decode = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };

  const enhanceProductDescription = () => {
    document.querySelectorAll('.product-description-wide .rte').forEach((description) => {
      const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        if (!walker.currentNode.parentElement.closest('script, style, .smart-faq')) nodes.push(walker.currentNode);
      }
      nodes.forEach((node) => {
        // Match a complete shortcode without consuming the surrounding product copy.
        const pattern = /\[sc_fs_multi_faq\b(?:[^\]"']|"[^"]*"|'[^']*')*\](?:\s*\[\/sc_fs_multi_faq\])?/g;
        const matches = [...node.textContent.matchAll(pattern)];
        if (!matches.length) return;
        const fragment = document.createDocumentFragment();
        let offset = 0;
        matches.forEach((match) => {
          fragment.append(document.createTextNode(node.textContent.slice(offset, match.index)));
          const attributes = new Map([...match[0].matchAll(/([\w-]+)\s*=\s*(["'])(.*?)\2/gs)].map((entry) => [entry[1], entry[3]]));
          const questions = [...attributes.keys()].filter((key) => /^question-\d+$/.test(key));
          if (!questions.length) {
            fragment.append(document.createTextNode(match[0]));
          } else {
            const faq = document.createElement('div');
            faq.className = 'smart-faq';
            const title = document.createElement('h2');
            title.className = 'smart-faq__title';
            title.textContent = 'Frequently asked questions';
            faq.append(title);
            questions.forEach((key) => {
              const details = document.createElement('details');
              const summary = document.createElement('summary');
              const answer = document.createElement('div');
              summary.textContent = decode(attributes.get(key));
              answer.className = 'smart-faq__answer';
              answer.textContent = decode(attributes.get(key.replace('question-', 'answer-')) || '');
              details.append(summary, answer);
              faq.append(details);
            });
            fragment.append(faq);
          }
          offset = match.index + match[0].length;
        });
        fragment.append(document.createTextNode(node.textContent.slice(offset)));
        // A shortcode-only paragraph can be replaced without nesting block content in a paragraph.
        const parent = node.parentElement;
        if (parent.tagName === 'P' && parent.childNodes.length === 1) parent.replaceWith(fragment);
        else node.replaceWith(fragment);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceProductDescription, { once: true });
  } else {
    enhanceProductDescription();
  }
  document.addEventListener('shopify:section:load', enhanceProductDescription);
})();
